import type { RecorderStatusTypes } from "../constants";
import { RECORDER_STATUS } from "../constants";

export const generateRandomString = () => {
  const array = new Uint8Array(5);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(36))
    .join("")
    .slice(0, 7);
};

export const getStatusProperties = (status: RecorderStatusTypes) => {
  const isRecording = status === RECORDER_STATUS.RECORDING;
  const isBusy =
    status === RECORDER_STATUS.UPLOADING ||
    status === RECORDER_STATUS.PROCESSING;
  const isError =
    status === RECORDER_STATUS.UPLOAD_ERROR ||
    status === RECORDER_STATUS.SERVER_ERROR;

  return { isRecording, isBusy, isError };
};

export const isPermissionGranted = async (
  setStatus: (status: RecorderStatusTypes) => void,
) => {
  try {
    const permission = await navigator.permissions.query({
      name: "microphone" as PermissionName,
    });

    if (permission.state !== "granted") {
      throw new Error("Microphone permission not granted");
    }
  } catch {
    setStatus(RECORDER_STATUS.WAITING_FOR_MIC_PERMISSION);
  }
};
